import React from 'react';
import { colors } from '../constants';

const ErrorIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
    className={props.className}
  >
    <path
      fill={props.color}
      d="M10 19.75C4.615 19.75.25 15.385.25 10S4.615.25 10 .25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75zm0-1.5c4.556 0 8.25-3.694 8.25-8.25S14.556 1.75 10 1.75 1.75 5.444 1.75 10s3.694 8.25 8.25 8.25zM9.25 4.728h1.5v6.656h-1.5V4.728zM10 15c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1z"
    />
  </svg>
);

ErrorIcon.defaultProps = {
  color: colors.mediumGrey,
  width: 20,
  height: 20,
};

export default ErrorIcon;
